import { useEffect, useState } from 'react';
import { AddMembership } from './AddMembership';
import ExerciseChartList from './ExerciseChartList';
import Info from './Info/Info';
import { ActiveTabIndicator, TopTab, TopTabContainer } from './styles';
import TagManager from 'react-gtm-module';

// 탭 클릭 핸들러
const TabbedNavigation = () => {
  const [activeTab, setActiveTab] = useState('info');

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isMemoModalOpen, setIsMemoModalOpen] = useState(false);

  const sessionActiveTab = sessionStorage.getItem('activeTab');

  useEffect(() => {
    if (sessionActiveTab) {
      setActiveTab(sessionActiveTab);
    }
  }, []);

  // 각자 상단 탭별로(회원정보, 수강권, 운동차트) 정보를 보여주는 함수
  const renderContent = () => {
    switch (activeTab) {
      case 'info':
        return (
          <Info
            isMemoModalOpen={isMemoModalOpen}
            setIsMemoModalOpen={setIsMemoModalOpen}
            isModalOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
          />
        );
      case 'ticket':
        return <AddMembership />;
      case 'chart':
        return (
          <div style={{ width: '100%', paddingBottom: '60px' }}>
            <ExerciseChartList />
          </div>
        );
      default:
        return <div>회원정보 내용</div>;
    }
  };

  const onClickTab = (tab: string) => {
    const tag =
      tab === 'info'
        ? 'customerinfo'
        : tab === 'ticket'
        ? 'membership'
        : 'exercisechart';
    TagManager.dataLayer({
      dataLayer: {
        event: 'customer_gdn_click',
        category: '회원관리',
        action: 'customer_gdn_click',
        tab: tag,
        value: 2
      }
    });
    setActiveTab(tab);
    sessionStorage.setItem('activeTab', tab);
  };

  return (
    <div>
      <TopTabContainer className="sticky top-0">
        <TopTab
          active={activeTab === 'info'}
          onClick={() => onClickTab('info')}
        >
          회원정보
          {activeTab === 'info' && <ActiveTabIndicator />}
        </TopTab>
        <TopTab
          active={activeTab === 'ticket'}
          onClick={() => onClickTab('ticket')}
        >
          수강권
          {activeTab === 'ticket' && <ActiveTabIndicator />}
        </TopTab>
        <TopTab
          active={activeTab === 'chart'}
          onClick={() => onClickTab('chart')}
        >
          운동차트
          {activeTab === 'chart' && <ActiveTabIndicator />}
        </TopTab>
      </TopTabContainer>
      <TopTabContainer>{renderContent()}</TopTabContainer>
    </div>
  );
};

export default TabbedNavigation;
